<template>
	<div class="page with-logo">
		<div class="logo-text">
			<div>
				<button @click="goBack" class="button back"/>
			</div>
		</div>

		<h1>Bonus Buttons</h1>
		<p>Get more out of your campaign with Bonus Buttons.</p>
		<p>Here are the current offers available for your campaign.</p>

		<ul class="add-ons">
			<li v-for="addOn in selectableAddOns" v-bind:key="addOn.name">
				<label :for="`checkbox-${addOn.name}`">
					<span class="description">
						<span class="add-on-name">{{addOn.displayName}}</span>
						<p v-html="addOn.description"></p>
					</span>
					<span class="price">
						<div>
							{{formatPriceLabel(addOn.netPrice)}}
							<span class="vat">+ VAT</span>
						</div>

						<div>
							<input type="checkbox" :id="`checkbox-${addOn.name}`" :value="addOn.name"
									v-model="checkedAddOns">
							<label :for="`checkbox-${addOn.name}`">&nbsp;</label>
						</div>
					</span>
				</label>
			</li>
		</ul>

		<p class="condition">*1: Please note: This Bonus Button only applies to one artist per order. If your boost is for more than one artist, you will be contacted to confirm which artist the Bonus Button applies to.</p>

		<button class="button gradient sunset" @click="confirmAddOns">
			<template v-if="checkedAddOns.length > 0">
				Confirm {{checkedAddOns.length}} {{pluralAddOnLabel}}
			</template>
			<template v-else>
				Skip Bonus Buttons
			</template>
		</button>
	</div>
</template>

<script>
    import basketHolderMixin from '../../mixins/basketHolder.js'
    import { formatPriceLabel } from '../../string-utils.js'

    export default {
        components: {},
        props: [
            'config', 'basket'
        ],
        data() {
            return {
                checkedAddOns: [],
            }
        },

        mixins: [
            basketHolderMixin
        ],

        computed: {
            selectableAddOns() {
                let selectableAddOns = []

                this.config.availableAddOns.forEach(addOnItem => {
                    if (this.promotionMeetsAddOnCriteria(addOnItem)) {
                        selectableAddOns.push(addOnItem)
                    }
                });

                return selectableAddOns
            },
            pluralAddOnLabel() {
                return this.checkedAddOns.length > 1 ? 'Bonus Buttons' : 'Bonus Button'
            }
        },

        methods: {
            promotionMeetsAddOnCriteria(addOn) {
                if (addOn.criteria.minImpressions && addOn.criteria.minImpressions > this.basket.impressions) {
                    return false
                }

                return true
            },
            confirmAddOns() {
                let newBasket = Object.assign({}, this.$route.params.basket, {
                    addOns: this.checkedAddOns
                })
                let newParams = Object.assign({}, this.$route.params, {basket: JSON.stringify(newBasket)})

                this.$router.push({
                    name: 'review',
                    params: newParams
                })
            },
            formatPriceLabel
        },

        mounted() {
            if (this.selectableAddOns.length === 0) {
                this.confirmAddOns()
            }
        }
    }
</script>

<style lang="scss" scoped>
	@import '../../../assets/scss/var';

	.page {
		// Allow space for search <input>, calendars etc. to be scrolled to the top, even when there is no content below them
		// XK: This serves as a partial fix for the CalendarPair scroll glitch where <transition> is briefly empty
		min-height: 2100px;
	}

	.add-ons {
		li {
			background: $color-white;
			border-radius: 2px;
			color: $color-ents24-boost-sea-green;
			margin-bottom: $gap-default;

			&:focus {
				background: $color-ents24-sunset-salmon;
			}

			label {
				display: flex;
				align-items: center;
				padding: $gap-default $gap-large;
				cursor: pointer;
			}

			.description {
				text-align: left;
				flex: 1;

				.add-on-name {
					display: block;
					font-weight: bold;
				}

				p {
					padding: 0;
					line-height: 1.5em;
					margin-bottom: 0;
					color: $color-grey-mid;
				}
			}

			.price {
				display: flex;
				flex-direction: column-reverse;
				font-weight: bold;
				font-size: 2rem;
				margin-left: 1em;
				white-space: nowrap;

				@media (min-width: 600px) {
					flex-direction: row;
					align-items: center;
				}

				.vat {
					display: inline-block;
					font-size: 1rem;
					font-weight: normal;
				}
			}

			input[type="checkbox"] + label {
				background-color: transparent;
			}
		}
	}

	p.condition {
		text-align: left;
	}
</style>

